import { Box, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSharedFolderOwners } from 'hooks'
import { ItemDetails, PeopleList } from 'components'
import { useIsSmallScreen } from 'packages/core'
import useSubcomponents from 'useSubcomponents'

const PaddedDiv = styled(Box)({
    padding: '0 31px',
})
const hasAccessToOwnerControl = 'ITShop-SharedFolders-Details-Owners-Control';
export const MoreInformationSection = ({ sharedFolder }: any) => {
    const { t } = useTranslation()
    const { hasAccessToControl } = useSubcomponents()
    const attributeOrientation = useIsSmallScreen() ? 'vertical' : 'horizontal'

    const { data: owners, isLoading: ownersLoading } = useSharedFolderOwners(
        hasAccessToControl(hasAccessToOwnerControl) ? sharedFolder.id : null,
    )

    return (
        <>
            {ownersLoading ? (
                <ItemDetails.AttributesContainer>
                    <PaddedDiv>
                        <ItemDetails.AttributesLoader />
                    </PaddedDiv>
                </ItemDetails.AttributesContainer>
            ) : (
                <>
                    {hasAccessToControl(hasAccessToOwnerControl) && <ItemDetails.AttributesContainer bottomPadding="0">
                        <PaddedDiv data-protectedsubcomponent={hasAccessToOwnerControl}>
                            <ItemDetails.Attribute
                                label={t('Common_Owners')}
                                value={<PeopleList list={owners} />}
                                orientation={attributeOrientation}
                            />
                        </PaddedDiv>
                    </ItemDetails.AttributesContainer>}

                </>
            )}
        </>
    )
}
